export const computeRHRate = (current: number, past: number) => {
  if (
    past == null ||
    current == null ||
    past === 0
  ) {
    return null;
  }
  return (current / past - 1) * 100;
};

export const add = (a: number, b: number) => {
  if (!isNaN(a) && !isNaN(b)) {
    return a + b;
  }
  if (!isNaN(a)) {
    return a;
  }
  if (!isNaN(b)) {
    return b;
  }
  return 0;
};
export const isGreaterThanMillion = (value: number) => 
    !isNaN(value) && Math.abs(value) >= 1000;